<script lang="ts">
	import type { Snippet } from 'svelte';

	type Props = {
		ready: boolean;
		children: Snippet;
	};

	const { ready, children }: Props = $props();
</script>

<div class="container" class:ready>{@render children()}</div>

<style lang="scss">
	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	.container {
		opacity: 0;
		animation: fadeIn 1s ease-in;

		&.ready {
			opacity: 1;
		}
	}
</style>
